import {
  mapFuncOverOneLoadable,
  mapFuncOverOneLoadableAndOneNormal,
} from '../../loadableUtils';
import {
  ICYDatum,
  IPYDatum,
  keyByMap,
} from '../../Utils';
export const getPYHash = (product_id: number, year: number) => product_id + '-' + year;

export const getCYHash = (location_id: number, year: number) => location_id + '-' + year;

// Convert array of PY data into map keyed by product + year combo:
export const convertDeflatorsToMap = mapFuncOverOneLoadable<IPYDatum[], Map<string, IPYDatum>>(
  keyByMap<string, IPYDatum>(({product_id, year}) => getPYHash(product_id, year)),
);

// Filter population data for one country:
export const filterPopulationData = mapFuncOverOneLoadableAndOneNormal<ICYDatum[], number, ICYDatum[]>(
  (data: ICYDatum[], country: number) =>
    data.filter(({location_id}) => location_id === country),
);

export const getAvailableYearsForDeflators = mapFuncOverOneLoadable<IPYDatum[], Set<number>>(
  (data: IPYDatum[]) => {
    const allYears = data.map(({year}) => year);
    return new Set(allYears);
  },
);

export const getPopulationPerYear = mapFuncOverOneLoadable<ICYDatum[], Map<number, number>>(
  (data: ICYDatum[]) => {
    const pairs = data.map(({population, year}) => ([year, population] as [number, number]));
    return new Map(pairs);
  },
);
